define('models/AdvantageModel',['underscore', 'app', 'ObjectModel', 'moment'],
    function (_, app, ObjectModel, moment) {

        var DISCOUNT_TRANSLATION_CONTEXT = 'discount',
            DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss ZZ',
            _FILTERS_ = ['current','available_now_account','next_strict'];
        //
        //
        //
        var AdvantageModel = ObjectModel.extend({
            idAttribute:'id_advantage',
            initialize: function () {
                var model = this;
                // model.set('discounts',[]);
                //model.on('sync', model.setup);

                model.setup();
            },
            getDiscounts: function () {
                return this.get('discounts');
            },
            getFilterClasses:function(){
               // return HTML class list for filter
               var classList = '', model = this;
                _(_FILTERS_).each(function(id){
                    if(model.get(id)===true) classList+=(classList===''?'':' ')+'filter-'+id;
                });
                return classList
            },
            getName:function(){
                return this.get('name');
            },
            getStatus:function(wrapped){
                var statusText = this.get('statusText'),
                    statusType = this.get('statusType');
                return wrapped ?
                    // status HTML wrapped
                    '<span class="status-type-'+statusType+'">'+statusText+'</span>':
                    // status text
                    statusText;
            },
            getPictureUrl:function(source, format){
                // sujet tricky lié à l'historique des contenus actualités (v1, app, etc.)
                var source = source || 'id_picture';
                format = format || '384x216';

                var    url = app.getPictureUrl(this.get(source),'Advantage',format,'JPG',this.getName());
                return url;
            },
            isUsable:function(onCart){
                var usable  = this.get('usable'+(onCart?'_on_cart':''));

                if (!onCart ||  !usable)
                    return usable;
                var cart = app.getCart();

                var allowed_stores = this.get('allowed_stores');
                if (allowed_stores)
                {

                    var store = cart.getStore();


                    if (!store)
                    {
                        return false;
                    }
                    if (allowed_stores.indexOf(store.id) < 0)
                    {
                        return false;
                    }



                }
                return usable;

            },
            isNext:function(){
                return this.get('next') && !this.get('current');
            },
            isUsedInCart:function(){
                var voucher = this.get('voucher');
                if(!voucher) return false;

                var cart = app.getCart(),
                    discounts = cart.getVoucher(),
                    discount = discounts.findWhere({name:voucher.toUpperCase()});




                return !!discount;
            },
            setup: function () {
                //
                // formate les discounts lors de la synchronisation
                //
                var model = this;
                //  discounts = _(this.get('discounts'));
                //
                function formatDate(date) {
                    var m = moment(date, DATE_FORMAT);
                    return m.isValid() ? m.format('LL'): false;
                }

                // apply options & string filters over discount datas,
                // for templating purposes
                var desc = '',
                    voucher = model.get('voucher'),
                    buttonIcon = '',
                    buttonLabel = '',
                    buttonDisabled = false,
                    buttonVisible = false,
                    current = model.get('current'),
                    next_strict = false,
                    usable = false,
                    usable_on_cart = false,
                    usable_type = false,
                    available_now = false,
                    available_now_account = false,
                    available_soon = false,
                    unavailable_status = model.get('unavailable_status'),
                    discount_available = model.get('available'),
                    date_use = model.get('date_use'),
                    error_message = model.get('error_message'),
                    available = model.get('available'),
                    display_voucher = model.get('display_voucher') === true,
                    end_date = model.get('end_date_neolane') || model.get('end_date_web');

                var statusText = '',
                    statusType = 'none',
                    used = false,
                    used_date = false;
                var expirationDateFormated = formatDate(end_date);

                if (available) {
                    available_now = current;
                    if (display_voucher) {
                        usable_type = 'voucher';
                        if(expirationDateFormated){
                            statusText = app.t('valable jusque au %s', DISCOUNT_TRANSLATION_CONTEXT, [expirationDateFormated]);
                            desc = app.t('Code %s valable jusque au %s', DISCOUNT_TRANSLATION_CONTEXT, [voucher, expirationDateFormated]);
                        }
                        statusType = 'active';
                    }
                } else {
                    switch (unavailable_status) {
                        case 2:

                            used = true;
                            used_date = date_use;
                            desc = app.t("Bon déja utilisé le %s", DISCOUNT_TRANSLATION_CONTEXT, [formatDate(date_use)]);
                            break;
                        case 3:
                            available_soon = true;
                            statusText = app.t('Prochainement', DISCOUNT_TRANSLATION_CONTEXT);
                            statusType = 'next';
                            desc = app.t("Ce n'est pas le encore le le moment, un peu de patience", DISCOUNT_TRANSLATION_CONTEXT);
                            break;
                        case 4:
                            desc = error_message;
                            break;
                        case 1:
                        default:
                            desc = app.t('le code %s est invalide ', DISCOUNT_TRANSLATION_CONTEXT, [voucher]);
                            statusText = app.t('Invalide', DISCOUNT_TRANSLATION_CONTEXT) ;
                            statusType = 'invalid';

                            break;
                    }
                }

                if (display_voucher) {
                    buttonVisible = true;
                    if (discount_available) {
                        buttonLabel = app.t('Ajouter au panier', DISCOUNT_TRANSLATION_CONTEXT);

                    } else {
                        buttonDisabled = true;
                        switch (unavailable_status) {
                            case 2:
                                buttonLabel = app.t("déja utilisé", DISCOUNT_TRANSLATION_CONTEXT, [formatDate(date_use)]);
                                buttonIcon = 'success';
                                break;
                            default:
                                buttonLabel = app.t('pas disponible ', DISCOUNT_TRANSLATION_CONTEXT, [voucher]);
                                buttonIcon = 'timer';
                                break;
                        }
                    }
                }
                if(model.get('id_product')){
                    // les produits sont "de facto" utilisable
                    buttonVisible = true;
                    usable_type = 'product';
                }

                usable = !buttonDisabled && buttonVisible && discount_available;

                if(!current){
                    statusType = 'none';
                }

                usable_on_cart = usable && !model.get('hide_on_cart');
                available_now_account = available_now && !model.get('hide_on_account');
                next_strict = model.get('next') && !current;



                model.set({
                    desc:desc, // TODO vérifier que ce paramètre est utile ?
                    // TODO et trouver un nom plus explicite pour la variable que "desc", car "description" existe déjà
                    statusText: statusText,
                    statusType: statusType,
                    available_now:available_now,
                    available_now_account:available_now_account,
                    available_soon:available_soon,
                    next_strict:next_strict,
                    used:used,
                    usable_on_cart:usable_on_cart,
                    usable_type:usable_type,
                    used_date:used_date,
                    usable:usable,
                })
            },

            getIcon:function(){
                return this.get('icon');
            },

            use:function(){
                //
                // use an advantage
                //
                var model = this,
                    cart = app.getCart(),
                    usable_type = model.get('usable_type');


                function off(){
                    model.stopListening(app,'addVoucher',used);
                    model.stopListening(app,'cancelVoucher',canceled);
                }

                function used(){
                    model.trigger('used');
                    off();
                }
                function canceled(){
                    model.trigger('canceled');
                    off();
                }

                switch(usable_type){
                    case 'voucher':
                        model.listenToOnce(app,'addVoucher',used);
                        model.listenToOnce(app,'cancelVoucher',canceled);
                        cart.addVoucher(model.get('voucher'));
                        break;
                    case 'product':
                        var id_product = model.get('id_product');
                        cart.addProduct(id_product)
                            .done(used)
                            .fail(canceled)
                        break;

                }

            },
            cancel:function(){
                //
                // cancel an advantage
                //
                var model = this,
                    cart = app.getCart(),
                    usable_type = model.get('usable_type');

                function canceled(){
                    model.trigger('canceled');
                }

                switch(usable_type){
                    case 'voucher':
                        model.listenToOnce(app,'cancelVoucher',canceled);
                        var voucher = model.get('voucher'),
                            discounts = cart.getVoucher(),
                            discount = discounts.findWhere({name:voucher.toUpperCase()}),
                            id_cart_discount = discount.id_cart_discount;
                        cart.removeVoucher(id_cart_discount);
                        break;

                }
            }

        });

        AdvantageModel._FILTERS_ = _FILTERS_;

        return AdvantageModel;

    });
